import { Box, Typography } from '@mui/material';

const columnOverrides = [
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
  },
  {
    field: 'produto',
    renderCell: ({ row }) => <ProdutoCell row={row} />,
  },
  {
    field: 'margem',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) + '%',
  },
  {
    field: 'status',
    renderCell: ({ value }) => (
      <div style={colorContainer(value)}>
        <span>{value}</span>
      </div>
    ),
  },
];

const colorContainer = (value) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: value === 'ATIVO' ? '#baffc9' : '#ffb3ba',
});

const ProdutoCell = ({ row }) => {
  const lines = [
    { label: 'Código', value: row?.produto_id },
    { label: 'Referência', value: row?.referencia },
  ];

  return (
    <Box flex={1} my={1}>
      <Typography fontWeight="bold" mb={1} variant="body1">
        {row?.produto}
      </Typography>
      {lines?.map(
        ({ label, value }, i) =>
          Boolean(value) && (
            <Box key={i?.toString()} display="flex">
              <Typography flex={1} variant="caption" fontWeight="bold">
                {label}:{' '}
              </Typography>
              <Typography flex={2} variant="caption">
                {value || '-'}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

export default columnOverrides;
